module.exports = __webpack_public_path__ + "img/vignettes-asso_0009_pitie-salpetriere.dc899164.jpg";